import { useEffect, useRef } from "react"

import { useAppDispatch } from "../../../hooks/use-app-dispatch.ts"
import { fetchUserInfo } from "../../User/redux/user.thunks.ts"
import { fetchAccessibleBranches } from "../redux/branches.slice.ts"

export const REVALIDATE_AFTER_MS = 60_000

/**
 * An operator can change a company's structure while someone has the app open.
 * The server enforces the new access on the next request regardless, so this
 * only keeps the screen honest: on coming back to the tab, the workspace and
 * permissions are read again, at most once a minute.
 */
export function useRevalidateBranchesOnReturn() {
  const dispatch = useAppDispatch()
  const lastReadAt = useRef(Date.now())

  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState !== "visible") return
      const now = Date.now()
      if (now - lastReadAt.current < REVALIDATE_AFTER_MS) return
      lastReadAt.current = now
      void dispatch(fetchAccessibleBranches())
      void dispatch(fetchUserInfo())
    }
    document.addEventListener("visibilitychange", onVisibilityChange)
    return () =>
      document.removeEventListener("visibilitychange", onVisibilityChange)
  }, [dispatch])
}
